document.addEventListener('DOMContentLoaded', function () {
  function setupFabricImage() {
    const images = Array.from(document.images);

    const fabricImage = images.find(function (img) {
      const width = img.naturalWidth;
      const height = img.naturalHeight;

      if (!width || !height) return false;

      const ratio = width / height;

      return width >= 800 && ratio > 1.3 && ratio < 1.7;
    });

    if (!fabricImage || fabricImage.dataset.fabricLightboxReady) return;

    fabricImage.dataset.fabricLightboxReady = 'true';

    const wrapper = document.createElement('div');
    wrapper.style.position = 'relative';
    wrapper.style.display = 'block';
    wrapper.style.width = '100%';

    fabricImage.parentNode.insertBefore(wrapper, fabricImage);
    wrapper.appendChild(fabricImage);

    const grid = document.createElement('div');
    grid.style.position = 'absolute';
    grid.style.inset = '0';
    grid.style.display = 'grid';
    grid.style.gridTemplateColumns = 'repeat(4, 1fr)';
    grid.style.gridTemplateRows = 'repeat(4, 1fr)';
    grid.style.zIndex = '10';

    for (let i = 0; i < 16; i++) {
      const button = document.createElement('button');

      button.type = 'button';
      button.setAttribute('aria-label', 'View fabric ' + (i + 1));
      button.style.background = 'transparent';
      button.style.border = '0';
      button.style.padding = '0';
      button.style.margin = '0';
      button.style.cursor = 'zoom-in';

      button.addEventListener('click', function () {
        const lightbox = document.createElement('div');

        lightbox.style.position = 'fixed';
        lightbox.style.inset = '0';
        lightbox.style.background = 'rgba(0,0,0,0.88)';
        lightbox.style.display = 'flex';
        lightbox.style.alignItems = 'center';
        lightbox.style.justifyContent = 'center';
        lightbox.style.zIndex = '999999';
        lightbox.style.padding = '20px';

        const enlarged = document.createElement('img');
        enlarged.src = fabricImage.currentSrc || fabricImage.src;
        enlarged.style.maxWidth = '95vw';
        enlarged.style.maxHeight = '95vh';
        enlarged.style.width = 'auto';
        enlarged.style.height = 'auto';
        enlarged.style.objectFit = 'contain';

        lightbox.appendChild(enlarged);

        lightbox.addEventListener('click', function () {
          lightbox.remove();
        });

        document.body.appendChild(lightbox);
      });

      grid.appendChild(button);
    }

    wrapper.appendChild(grid);
  }

  setupFabricImage();

  window.addEventListener('load', setupFabricImage);

  setTimeout(setupFabricImage, 1000);
  setTimeout(setupFabricImage, 3000);
});